module.exports = __webpack_public_path__ + "static/img/no_photo.59688a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/SmartLivestock/slaughterHouse/static/no_photo.png
// module id = elm1
// module chunks = 209